import { Box, Card, Text, VStack, Icon, Button, Heading } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const SubmissonCard = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minH="60vh"
      p={{ base: 4, md: 6 }}
    >
      <Card.Root
        maxW="2xl"
        width="100%"
        borderWidth="1px"
        borderColor="border"
        shadow="lg"
        overflow="hidden"
      >
        <Card.Body p={{ base: 8, md: 12 }}>
          <VStack gap={8} textAlign="center">
            {/* Success Icon */}
            <Box
              bg="green.subtle"
              p={6}
              borderRadius="full"
              display="inline-flex"
              borderWidth="2px"
              borderColor="green.muted"
            >
              <Icon color="green.fg" fontSize="5xl">
                <CheckCircle />
              </Icon>
            </Box>

            {/* Main Thank You Message */}
            <VStack gap={4}>
              <Heading
                size={{ base: 'xl', md: '2xl' }}
                fontWeight="bold"
                letterSpacing="tight"
                color="fg"
              >
                Tack för din ansökan!
              </Heading>

              <Text
                fontSize={{ base: 'md', md: 'lg' }}
                color="fg.muted"
                lineHeight="tall"
                maxW="lg"
              >
                Vi har tagit emot din hyresansökan och kommer att granska den noggrant. Om vi har en
                bostad som passar dina önskemål kontaktar vi dig inom kort.
              </Text>
            </VStack>

            {/* Info Cards */}
            <VStack gap={3} w="full" pt={4}>
              <NavLink to="/" style={{ width: '100%' }}>
                <Button colorPalette="blue" size="lg" width="100%">
                  Tillbaka till startsidan
                </Button>
              </NavLink>
              <NavLink to="/available-properties" style={{ width: '100%' }}>
                <Button variant="outline" colorPalette="blue" size="lg" width="100%">
                  Se lediga bostäder
                </Button>
              </NavLink>
            </VStack>
          </VStack>
        </Card.Body>
      </Card.Root>
    </Box>
  );
};

export default SubmissonCard;
